import React from 'react';
import { Document, Page, View, Image } from '@react-pdf/renderer';
import PdfTab from './PdfTab';
import logo from './AssistPoint_Logo.png';
import MorphoSysPrescriptionPdf from './MorphoSysPrescriptionPdf';
import MorphoSysRequestType from './MorphoSysRequestType';

const styles = {
    page: { paddingTop: 35, paddingBottom: 35, paddingHorizontal: 35 }
}

const FREE_DRUG = 2;

const MorphoSysPdf = props => {
    const { form, tabs } = props;

    //The API DigitalFormService.GetFormMeta includes an exception to add BI
    //to the list of services if we auto-generate a BI to send
    const morphosysPrescriptionPage = form.meta.serviceCategoryIds.includes(FREE_DRUG)
        ? <MorphoSysPrescriptionPdf form={form} />
        : null;

    return <Document>
        <Page size="A4" style={styles.page}>
            <View>
                <View>
                    <Image src={logo} size='small' style={{ width: 200 }} />
                </View>

                <MorphoSysRequestType categories={form.meta.serviceCategoryIds} />

                {tabs.map(tab =>
                    <PdfTab
                        key={tab.key}
                        name={tab.name}
                        sections={tab.sections}
                        form={form}
                    />
                )}
            </View>
        </Page>
        {morphosysPrescriptionPage}
    </Document>
}

export default MorphoSysPdf;
